import { c as _c } from "react/compiler-runtime";
import type { Collaborators } from '@/types/github';
import { useQuery } from '@tanstack/react-query';
import { collaboratorsQueryKey, fetchCollaborators } from './query-keys';
export function useCollaborators(owner, repo, options) {
  const $ = _c(18);
  const areParamsValid = Boolean(owner && repo);
  let t0;
  if ($[0] !== areParamsValid || $[1] !== options?.requireComplete || $[2] !== owner || $[3] !== repo) {
    t0 = areParamsValid ? [...collaboratorsQueryKey(owner, repo), ...(options?.requireComplete ? ["complete"] : [])] : ["collaborators", "invalid"];
    $[0] = areParamsValid;
    $[1] = options?.requireComplete;
    $[2] = owner;
    $[3] = repo;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  let t1;
  if ($[5] !== options?.requireComplete || $[6] !== owner || $[7] !== repo) {
    t1 = t2 => {
      const {
        signal
      } = t2;
      return fetchCollaborators(owner, repo, signal, options?.requireComplete);
    };
    $[5] = options?.requireComplete;
    $[6] = owner;
    $[7] = repo;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  const t2 = areParamsValid && (options?.enabled ?? true);
  let t3;
  if ($[9] !== options?.requireComplete) {
    t3 = options?.requireComplete ? {
      placeholderData: _temp
    } : {};
    $[9] = options?.requireComplete;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const t4 = options?.retry;
  const t5 = options?.requireComplete ? 60000 : 21600000;
  let t6;
  if ($[11] !== t0 || $[12] !== t1 || $[13] !== t2 || $[14] !== t3 || $[15] !== t4 || $[16] !== t5) {
    t6 = {
      queryKey: t0,
      queryFn: t1,
      enabled: t2,
      ...t3,
      refetchOnWindowFocus: false,
      retry: t4,
      staleTime: t5
    };
    $[11] = t0;
    $[12] = t1;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return useQuery(t6);
}
function _temp() {}